<template>
  <Loading v-if="isLoading" :type="1" />
  <GenericList
    v-else
    :dataSet="historyLogs"
    :binding="binding"
    :columnsMetaData="columnsMetaData"
    @paginateClicked="getHistoryLogs"
    :prevPageRequest="prevPage"
    :nextPageRequest="nextPage"
  >
    <div slot="header" id="history-header">
      <b-row no-gutters=""
        ><h4 class="font-weight-normal">
          {{ "sections.historySection.title" | i18n }}
        </h4></b-row
      >
      <b-row no-gutters="">
        <h6 class="font-weight-lighter text-light">
          {{ "sections.historySection.timelapse" | i18n }}
        </h6></b-row
      >
    </div>
    <GenericPaginationSubHeader
      slot="subheader"
      :from="from"
      :to="to"
      :total="totalHistoryLogs"
      :text="$i18n.t('sections.historySection.entry')"
    />
  </GenericList>
</template>

<script>
import {
  Loading,
  StateCircleColor,
  GenericPaginationSubHeader,
  GenericList
} from "@/components";
/**
 * @description Affiche les bascules d'un logiciel par mois
 * @author Samuel Colassin
 * @vue-prop {String} softwareId - L'id du logiciel
 * @vue-data {Boolean} isLoading - Si la page est en train de charger
 * @vue-data {Object} historyLogs - Objet JSON de toutes les bascules du logiciel
 * @vue-data {Number} totalHistoryLogs - La quantité totale des bascules
 * @vue-data {Number} from - Le n ième logiciel au début de la page courante
 * @vue-data {Number} to - Le n ième logiciel à la fin de la page courante
 * @vue-data {String} nextPage - L'url de la prochaine page dans la pagination
 * @vue-data {String} prevPage - L'url de la précédente page dans la pagination
 * @vue-data {Object} binding - Les données de liaison
 * @vue-data {Array} columnsMetaData - Les données des colonnes
 */
export default {
  components: {
    Loading,
    GenericList,
    GenericPaginationSubHeader
  },
  name: "ListBalanceStateSection",
  props: {
    softwareId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      isLoading: true,
      historyLogs: [],
      totalHistoryLogs: 0,
      from: 0,
      to: 0,
      nextPage: "",
      prevPage: "",
      binding: {
        etat_courant: {
          component: {
            type: StateCircleColor,
            props: p => {
              return {
                state: p.etat_courant
              };
            }
          }
        },
        raison: {},
        created_at: {},
        cpu: {}
      },
      columnsMetaData: [
        {
          name: this.$i18n.t("sections.historySection.status"),
          class: "col-2 text-break"
        },
        {
          name: this.$i18n.t("sections.historySection.cause"),
          class: "col-10 col-md-5 col-lg-6"
        },
        {
          name: this.$i18n.t("sections.historySection.date"),
          class: "col-3 d-none d-md-block text-break"
        },
        {
          name: this.$i18n.t("sections.historySection.cpuState"),
          class: "col-md-2 col-lg-1 d-none d-md-block text-break text-right"
        }
      ]
    };
  },
  /**
   * @description Effectue une première requête pour injecter l'information dans la composante
   */
  async beforeMount() {
    await this.getHistoryLogs();
  },
  methods: {
    /**
     * @description Effectue une requête pour obtenir les informations à afficher dans la composante
     * @param {String} requestedPage L'url de la page demandée
     */
    async getHistoryLogs(requestedPage = "") {
      this.$api
        .getSoftwareMonthHistory(this.softwareId, requestedPage)
        .then(res => {
          this.historyLogs = res.data.data;
          this.totalHistoryLogs = res.data.meta.total;
          this.from = res.data.meta.from || 0;
          this.to = res.data.meta.to || 0;
          this.nextPage = res.data.links.next || "";
          this.prevPage = res.data.links.prev || "";
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  }
};
</script>
